
import React from "react";
import { LeadAccount } from "@/types/strategy-types";
import { Table, TableBody } from "@/components/ui/table";
import LeadAccountTableRow from "./LeadAccountTableRow";
import LeadAccountsTableHeader from "./LeadAccountsTableHeader";

interface LeadAccountsTableContentProps {
  filteredLeadAccounts: LeadAccount[];
  onEdit: (leadAccount: LeadAccount) => void;
  onDelete: (leadAccount: LeadAccount) => void;
}

const LeadAccountsTableContent = ({
  filteredLeadAccounts,
  onEdit,
  onDelete
}: LeadAccountsTableContentProps) => {
  return (
    <div className="rounded-md border">
      <Table>
        <LeadAccountsTableHeader />
        <TableBody>
          {filteredLeadAccounts.length === 0 ? (
            <tr>
              <td colSpan={6} className="h-24 text-center">
                No lead accounts found with the current filters.
              </td>
            </tr>
          ) : (
            filteredLeadAccounts.map(leadAccount => (
              <LeadAccountTableRow
                key={leadAccount.id}
                leadAccount={leadAccount}
                onEdit={onEdit}
                onDelete={onDelete}
              />
            ))
          )}
        </TableBody>
      </Table>
    </div>
  );
};

export default LeadAccountsTableContent;
